export default __webpack_public_path__ + "static/media/ri_book-2-line.841750b7.svg";